module.exports = [{
      plugin: require('/Users/ben/dev/2019-portfolio/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
